
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 489.935 489.935"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M486.617 255.067c4.6-6.3 4.4-14.9-.5-21-74.1-91.1-154.1-137.3-237.9-137.3-142.1 0-240.8 132.4-244.9 138-4.6 6.3-4.4 14.9.5 21 74 91.2 154 137.4 237.8 137.4 142.1 0 240.8-132.4 245-138.1zm-245 103.8c-69.8 0-137.8-38.4-202.4-114 25.3-29.9 105.7-113.8 209-113.8 69.8 0 137.8 38.4 202.4 114-25.3 29.9-105.7 113.8-209 113.8z","fill":"#0d69d5","data-original":"#000000"}}),_c('path',{attrs:{"d":"M244.917 157.867c-48 0-87.1 39.1-87.1 87.1s39.1 87.1 87.1 87.1 87.1-39.1 87.1-87.1-39.1-87.1-87.1-87.1zm0 139.9c-29.1 0-52.8-23.7-52.8-52.8s23.7-52.8 52.8-52.8 52.8 23.7 52.8 52.8-23.7 52.8-52.8 52.8z","fill":"#0d69d5","data-original":"#000000"}})])])
          )
        }
      }
    